const roobertFont = {
  fontFamily: 'Roobert',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: `url(../public/cmsAssets/fonts/Roobert/Roobert-Light.woff2) format('woff2')`,
};

export const components = {
  MuiCssBaseline: {
    styleOverrides: {
      '@global': {
        '@font-face': [roobertFont],
      },
    },
  },
};
